import { EMenuActionsTypes } from '@enums/common';

export const searchTooltipText = 'Search by parameter name';
export const BRANCH_TABLE_SIZE = 'calc(80vh + 80px)';
export const PARAMETER_TABLE_SIZE = '65%';
export const filterWidth = '200px';

export const exportBranchActions = [
	{
		text: 'Current page',
		id: EMenuActionsTypes.currentPage,
		disabled: false,
	},
	{
		text: 'All filtered',
		id: EMenuActionsTypes.allFiltered,
		disabled: false,
	},
	{
		text: 'All',
		id: EMenuActionsTypes.all,
		disabled: false,
	},
];
